
      import '@folkjs/labs/standalone/folk-shape';
      import '@folkjs/labs/standalone/folk-projector';

      const projector = document.querySelector('folk-projector');

      function XYCell(shape) {
        const editor = document.createElement('div');
        const xInput = document.createElement('input');
        const yInput = document.createElement('input');
        xInput.type = 'number';
        yInput.type = 'number';

        xInput.value = shape.x;
        yInput.value = shape.y;

        xInput.addEventListener('input', (e) => (shape.x = Number(e.target.value)));
        yInput.addEventListener('input', (e) => (shape.y = Number(e.target.value)));

        editor.appendChild(xInput);
        editor.appendChild(yInput);
        return editor;
      }

      const shapes = document.querySelectorAll('folk-shape');
      shapes.forEach((shape) => {
        projector.mapping(shape, XYCell);
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'v') {
          projector.project();
        }
      });

      document.addEventListener('click', (event) => {
        if (event.target === document.body || event.target === projector) {
          projector.project();
        }
      });
    